// extracted by mini-css-extract-plugin
export default {"content":"AiPhotoGenerationMailSpacePromo__content--aCaD4","imageWrapper":"AiPhotoGenerationMailSpacePromo__imageWrapper--3Fd0B"};